import elementLocaleTR from "element-react/src/locale/lang/tr-TR";

let tr = {
  translation: {
    // ------- Sidebar
    home: "Dashboard",

    //Accounts

    accounts: "Hesabım",
    profile: "Profil",
    emailCannotChange: "E-posta adresiniz Araçiste'deki kimliğinizdir ve giriş yapmak için kullanılır. Bu alan değiştirilemez.",
    uploadAvatar: "Profil Resmi Yükle",
    clearAvatar: "Temizle",

    changepassword: "Şifre Değiştir",

    //Parameters

    parameters: "Parametreler",
    parameter: "Parametre",
    startTimeTolerance: "Başlangıç Saati Toleransı (Dk.)",
    endTimeTolerance: "Bitiş Saati Toleransı (Dk.)",
    progressPaymentMinVisitCheck: "Hakediş Min. Ziy. Oranı Denetle",
    minimumStopVisitRate: "Min. Durak Ziyaret Oranı (%)",
    vehicleMoveTimeTolerance: "Hareket Saati Toleransı (Dk.)",
    progressPaymentWeekend: "Hakediş Hafta Donu Dahil",
    employeeTimeTolerance: "Personel Gecikme Toleransı",
    materialCreateTime: "Malzeme Oluşturma Zamanı",
    stopRadius: "Geçiş Çapı (Mt.)",
    vehicleDeviceProvider: "Servis Sağlayıcı",
    vehicleCapacityPercentage: "Araç Kapasite Kullanım Oranı (%)",
    isVehicleCapacityPass : "Araç Kapasite Kullanım Limiti Pas Geçilsin mi?",
    routeServiceIntegration: "Entegrasyonlu Sefer Yaratma",
    routeServiceDeleteBufferTime: "Araç Atama İptal Süresi (Saat)",

    // VehicleDeviceProviders

    vehicledeviceproviders: "Servis Sağlayıcılar",
    vehicledeviceprovider: "Servis Sağlayıcı",
    isCardReaderService : "Kart Okutma Hizmeti Var Mı?",

    // VehicleTypes

    vehicletypes: "Araç Tipleri",
    vehicleType: "Araç Tipi",

    customeroperations: "Müşteri İşlemleri",
    vehicleoperations: "Araç İşlemleri",

    // CustomerGroups

    customergroups: "Müşteri Grupları",
    customerGroup: "Müşteri Grubu",
    domain: "Domain",
    loginType: "Giriş Tipi",
    standart: "Standart",
    singleSignOn: "Single Sign On (SSO)",

    // Customers

    customers: "Müşteriler",
    customer: "Müşteri",
    route: "Güzergah",
    isProgressPayment: "Hakediş Onayı",
    isRouteApproval: "Kullanıcı Güzergah Kayıtlarını Onaya Gönder",
    calculationType: "Hesaplama Türü",
    serviceType : "Hizmet Tipi",
    serviceTypeFull : "İhalesi Zer Tarafından Tapılan",
    serviceTypePlatform : "Sadece Platform Hizmeti",
    full : "İhalesi Zer Tarafından Tapılan",
    platform : "Sadece Platform Hizmeti",
    progressPaymentApproveType : "Hakediş Onay Tipi",
    stopRate : "Durak Yüzdesi",
    locationControl : "Lokasyon Kontrolü",
    isProblemCheck : "Hakediş Onayı İçin Şikayetler Kontrol Edilsin Mi?",


    // CustomerSharingGroup

    customersharinggroups: "Müşteri Paylaşım Grupları",
    customerSharingGroup: "Müşteri Paylaşım Grubu",
    isRouteSharing: "Güzergah Paylaşımı",

    // Vendors
    vendors: "Tedarikçiler",
    vendor: "Tedarikçi",
    vendorCreate: "Tedarikçi ekle",

    // Users
    users: "Kullanıcılar",
    user: "Kullanıcı",
    userCreate: "Kullanıcı ekle",
    cardId: "Kart Id",
    SystemAdministrator: "Sistem Yöneticisi",
    TechnicalAdministrator: "Teknik Yönetici",
    CustomerAdmin: "Müşteri Yöneticisi",
    CustomerLocationOfficer: "Müşteri Lokasyon Yöneticisi",
    Vendor: "Tedarikçi",
    Driver: "Sürücü",

    // Vehicles

    vehicles: "Araçlar",
    vehicle: "Araç",
    plate: "Plaka",
    brand: "Marka",
    model: "Model",
    year: "Yıl",
    vehicleDetails: "Araç Detayları",
    devices: "Cihazlar",
    deviceId: "Cihaz Id",
    activationDate: "Aktivasyon Tarihi",
    deactivationDate: "Durdurulma Tarihi",
    lastProgressPaymentDate : "Son Hakediş Tarihi",

    // Contracts
    contracts: "Sözleşmeler",
    contract: "Sözleşme",
    contractCreate: "Sözleşme Oluştur",
    contractDetail : "Sözleşme Detayı",
    contractEdit : "Sözleşme Düzenle",
    approveStatus : "Onay Durumu",
    waitingForApproval : "Onay Bekliyor",
    rejected : "Reddedildi",
    start : "Başlat",
    exportRoute : "Güzergah Aktarım",
    isFinished : "Süre",
    continues : "Devam Ediyor",
    copy : "Kopyala",


    // Routes

    routes: "Güzergahlar",
    routeCreate: "Güzergah Oluştur",
    routeEdit: "Güzergah Düzenle",
    departureDistance: "Gidiş (Km)",
    returnDistance: "Dönüş (Km)",
    totalDistance: "Toplam (Km)",
    routeType: "Güzergah Tipi",
    normalSingle: "Normal Tek",
    shiftOne: "Vardiya 1",
    shiftOneSingle: "Vardiya 1 Tek",
    shiftTwo: "Vardiya 2",
    shiftTwoSingle: "Vardiya 2 Tek",
    single: "Tek",
    departure: "Gidiş",
    return: "Dönüş",
    departureTime: "Gidiş Süresi (Dk)",
    returnTime: "Dönüş Süresi (Dk)",
    days: "Günler",

    Sunday: "Pzr",
    Monday: "Pzts",
    Tuesday: "Sal",
    Wednesday: "Çar",
    Thursday: "Per",
    Friday: "Cum",
    Saturday: "Cmt",
    vehiclePlaningType : "Araç Planlaması",
    complete : "Tamamlandı",
    planning : "Devam Ediyor",

    //Services

    services: "Seferler",
    service: "Sefer",
    directionType: "Sefer Tipi",
    buffer: "Buffer",
    shift: "Vardiya",
    departureDuration: "Gidiş Süresi",
    numberOfPassenger: "Yolcu Sayısı",


    //Vehicleassignments
    vehicleassignments: "Araç Atamaları",
    vehicleAssignment: "Araç Atama",
    pending: "Atama Bekliyor",
    partial: "Kısmi Atama Yapıldı",
    assigned: "Atama Yapıldı",
    serviceStatus: "Durum",

    //User Services
    userService : "Servis Kullanımı",
    userservices : "Servis Kullanımları",
    userServiceApproval : "Servis Kullanımı Onay",
    approvalStatus : "Onay Durumu",
    stop : "Durak",
    onetime : "Tek Seferlik",
    type : "Tip",
    boardingPass : "Biniş Belgesi",

    //Problems
    problems : "Sorun Bildirimleri",
    problem : "Sorun Bildirimi",

    //ProgressPayments

    progresspayments : "Hakedişler",
    progressPayment : "Hakediş",
    planned : "Planlanan",
    actual : "Gerçekleşen",
    percentageOfStop : "Durak %",
    actualStopPercentage : "Durak %",
    percentageOfPassengerOccupancy : "Doluluk %",
    waitingForCustomerApproval :  "Müşteri Onayı Bekliyor",
    approved :  "Onaylandı",
    failed :  "Gerçekleşmedi",
    rejectedByCustomer : "Müşteri tarafından reddedildi",
    details : "Hakediş Detayı",
    boardingDate : "Biniş Zamanı",
    bridge : "Köprü",
    highway : "Otoban",
    progresspaymentapproval : "Hakediş Onayları",
    progresspaymentperiods : "Hakediş Onayları",
    waitingForSendByVendor : "Onay için hazır",
    approvedByCustomer : "Müşteri onayladı",
    correction: "Düzeltme",
    equipment : "Ekipman",
    material : "Malzeme",
    

    // System Notifications
    systemnotifications : "Bildirimler",
    subject : "Konu",
    notificationType : "Bildirim Tipi",
    general : "Herkese",
    routePassenger : "Bir Güzergaha'a Ait Tüm Yolculara",
    servicePassenger : "Bir Sefer'e Ait Tüm Yolculara",
    serviceVehiclePassenger : "Bir Aracın Tüm Yolcularına",
    serviceVehicle : "Araç Yolcularına",
    sent : "Gönderildi",
    sending : "Gönderiliyor",
    channel : "Kanal",
    push : "Push Bildirim",


    //Repors

    progresspaymentperiodreport: "Hakediş Dönem Raporu",
    serviceusagereport : "Servis Kullanım Raporu",
    mobile : "Mobil Uygulama",
    cardReader : "Kart Okuyucu",
    httplogs : "Http Logları",
    elapsedMilliseconds : "İşlem Süresi",
    vehiclereports : "Araç Raporu",
    routeperformancereport : "Güzergah Performans Raporu",
    usage : "Kullanım",
    progressPaymentPlanned : "Planlanan Hakediş",
    progressPaymentActual : "Gerçekleşen Hakediş",

    //

    companyOperations: "Şirketler",
    companyDefine: "Şirket Tanımla",
    companyCreate: "Şirket Tanımla",
    companyList: "Şirket Listesi",
    companyEdit: "Şirket Düzenleme",

    membershipOperations: "Üyelik",
    membershipMembers: "Üyeler",
    members: "Üyeler",
    activationcreate: "Yeni Üye Ekle",
    membershipActivationcreate: "Yeni Üye Ekle",

    membershipActivationList: "Aktivasyonlar",
    activationList: "Üye Aktivasyonları",

    membership: "Üyelik İşlemleri",
    activationLinkCopy: "Aktivasyon linkini kopyala",

    definitions: "Tanımlar",
    offices: "Ofisler",
    office: "Ofisler",
    aOffice: "Ofis",
    sectors: "Sektörler",
    location: "Lokasyon",
    locations: "Lokasyonlar",
    skill: "Yetenek",
    skills: "Yetenekler",
    meetingRoomCategories: "Toplantı Odası Kategorileri",
    meetingroomcategories: "Toplantı Odası Kategorisi",
    meetingRoom: "Toplantı Odaları",
    meetingroom: "Toplantı Odası",

    reservation: "Rezervasyon",
    networking: "Topluluk",

    reports: "Raporlar",

    settings: "Ayarlar",

    // ------- Roles
    member: "Üye",
    memberAdmin: "Şirket Yöneticisi",
    systemAdmin: "Sistem Yöneticisi",

    // ------- Global
    default: "Varsayılan",
    kosocial: "Kosocıal",
    continue: "Devam",
    pleaseToggleMenu: "Alt sekmeler için menüyü genişletebilirsin.",
    id: "ID",
    other: "Diğer",
    date: "Tarih",
    pleaseAddData: "Lütfen {{type}} bilgilerini eklemek için butona basınız!",
    createdDate: "Oluşturma Tarihi",
    lastModifiedDate: "Güncelleme Tarihi",
    edit: "Düzenle",
    create: "Ekle",
    delete: "Sil",
    active: "Aktif",
    inactive: "Pasif",
    removed: "Silinmiş",
    emptyData: "Kayıt bulunamadı",
    defineType: "{{type}} Tanımla",
    errorGettingDataList:
      "{{type}} listesini alırken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.",
    errorGettingData:
      "{{type}} verilerini alırken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.",
    errorInvalidUsernameOrPassword: "Kullanıcı adı veya şifre yanlış",
    loading: "Yükleniyor...",
    search: "Ara",
    ok: "Tamam",
    message: "Mesaj",
    noData: "Aradığınız kriterlerde veri bulunamadı.",
    cancel: "İptal",
    deleteWarningText: "Kalıcı olarak silinecektir, onaylıyor musunuz?",
    deleteWarningTextCard:
      "Kart bilgilerin kalıcı olarak silinecek, onaylıyor musun?",
    warning: "Uyarı",
    error: "Hata",
    success: "Başarılı",
    save: "Kaydet",
    saved: "Kaydedildi",
    userName: "Kullanıcı Adı",
    monday: "Pazartesi",
    mon: "Pzt",
    tuesday: "Salı",
    tue: "Sal",
    wednesday: "Çarşamba",
    wed: "Çarş",
    thursday: "Perşembe",
    thu: "Perş",
    friday: "Cuma",
    fri: "Cum",
    saturday: "Cumartesi",
    sat: "Cmt",
    sunday: "Pazar",
    sun: "Pzr",
    day: "Gün",
    loadMore: "Daha Fazla",
    hour: "Saat",
    person: "Kişi",
    and: "Ve",
    all: "Tümü",
    today: "Bugün",
    tomorrow: "Yarın",
    thisWeek: "Bu Hafta",
    thisMonth: "Bu Ay",
    welcomeMessage: "Hoş Geldin {{name}}!",
    successSave: "{{type}} başarıyla kaydedildi.",
    successEdit: "{{type}} başarıyla kaydedildi.",
    successDelete: "{{type}} silme işlemi başarıyla tamamlandı.",
    unknownErrorOccurred:
      "Bilinmeyen bir hata meydana geldi. Lütfen daha sonra tekrar dene.",
    typeDeleted: "{{type}} Silinmiş",
    unassigned: "Atanmamış",
    noDataYet: "Henüz hiçbir veri yok",
    new: "Yeni",
    formEditTitle: "{{name}} {{type}}",


    // ------- Auth
    oneClickAwayInTheFamily: "Ailenin tamamı bir tık uzağında...",
    signInToYourAccount: "Giriş yapın",
    email: "E-posta",
    typeYourEmail: "E-posta adresinizi yazınız",
    emailInvalid: "Geçerli bir e-posta adresi yazınız",
    urlInvalid: "Geçerli bir url yazınız",
    password: "Şifre",
    confirmPassword: "Şifre doğrulama",
    typeYourPassword: "Şifrenizi yazınız",
    reTypeYourPassword: "Şifrenizi yeniden yazınız",
    signIn: "Giriş yap",
    forgotPassword: "Şifremi unuttum",
    language: "Dil",
    english: "English",
    turkish: "Türkçe",
    privacyTermsLabel:
      "Giriş yaparak gizlilik ve hizmet şartlarımızı kabul etmiş sayılırsınız.",
    noWorries:
      "Telaşa gerek yok! Sadece e-postanızı girin ve size giriş talimatlarını gönderelim.",
    sendMeInstructions: "Bana Talimatları Gönder",
    goToBack: "Geri dön",
    activation: "Aktivasyon",
    justOneClick: 'OfficeLink li olmaktan yalnızca birkaç "tık" uzaktasın!',
    savePassword: "Şifreyi Kaydet",
    helpIsOnTheWay: "Yardım Yolda!",
    helpIsOnTheWayLabel:
      "Belirttiğiniz e-posta adresine ait aktif bir kullanıcı bulunması halinde şifre değiştirme bağlantısı içeren e-posta tarafınıza gönderilecektir.",
    logout: "Oturumu Kapat",
    passwordCharacterLengthFail: "Şifre en az 8 karakterden oluşmalıdır.",
    passwordDigitFail: "Şifre en az bir rakam içermelidir.",
    passwordAzFail: "Şifre en az bir büyük/küçük harf içermelidir.",
    passwordsNotMatch: "Şifreler eşleşmiyor.",
    errorWhileSigning: "Oturum açarken bir hata meydana geldi.",
    checkYourEmail: "Lütfen email adresinizi kontrol ediniz!",

    // ------- Company
    companyType: "Şirket Tipi",
    companies: "Şirketler",
    membershipCompanies: "Şirketler",
    companiesCreate: "Ekle",
    companiesEdit: "Düzenle",
    team: "Takımlar",
    companiesNewComers: "Topluluktaki Yeni Şirketler",
    teamNewComers: "Yeni Üyeler",
    corporatePersonalInformation: "Tüzel/Şahıs Bilgisi",
    corporate: "Tüzel",
    personal: "Şahıs",
    businessType: "Üyelik Kategorisi",
    companyName: "Şirket Adı",
    companyLogoAdd: "Logo Ekle",
    sector: "Sektör",
    abilities: "Yetenekler",
    companyLogo: "Şirket Logosu",
    companyBio: "Şirket Hakkında",
    status: "Durum",
    reserveCapacity: "Toplantı Odası Rezerve Etme Kapasitesi",
    capacityExceedingSwitch:
      "Kapasitesinin aşılması durumunda toplantı odası rezervasyonuna devam edilsin mi?",
    appearKoDirectory: "Şirket Topluluk’da görünsün mü?",
    send: "Gönder",
    sapID: "Sap ID",
    sapCompanyName: "SAP Şirket Adı",
    freelancer: "Freelancer",
    startup: "Startup",
    VC: "VC / Yatırımcı",
    corporateBT: "Kurumsal",
    agency: "Butik Şirket / Ajans",
    addCompanyLogo: "Şirket Logosu Ekle",
    isEmployeesVisibleInKoDirectory: "Üyeler Topluluk’da görünsün mü?",
    isPassDebitCard: "Ön ödemeli veya yabancı kart kontrolü pas geçilsin mi?",
    isNewOfficeDistribute: "Yeni ofis eklendiğinde tüm üyelere eklensin mi?",
    addImage: "Görsel Ekle",
    nomad: "Gezgin",
    virtualWithoutUsage: "Kullanımsız Sanal Adres",
    virtualWithUsage: "Kullanımlı Sanal Adres",
    privateOffice: "Ofis",
    fixedDesk: "Sabit Masa",
    membershipType: "Üyelik Tipi",
    membershipInfo: "Üyelik Bilgileri",
    deleteMember: "Üyeyi sil",
    taxOffice: "Vergi Dairesi",
    taxId: "Vergi Numarası",
    country: "Ülke",
    invoiceEmail: "Fatura E-posta Adresi",

    VirtualNoUsage: "Kullanımsız Sanal Adres",
    VirtualYesUsage: "Kullanımlı Sanal Adres",
    PrivateOffice: "Ofis",
    FixedDesk: "Sabit Masa",
    MeetingRoomMembership: "Toplantı Odası Üyeliği",
    meetingroommembership: "Toplantı Odası Üyeliği",
    MembershipType: "Üyelik Tipi",
    MembershipInfo: "Üyelik Bilgileri",

    // ------- Definitions
    locationsList: "Lokasyon Listesi",
    locationDefine: "Lokasyon Tanımla",
    locationCreate: "Lokasyon Tanımla",
    locationsDefine: "Lokasyon Tanımla",
    locationsCreate: "Lokasyon Tanımla",
    locationEdit: "Lokasyon Düzenle",
    locationsEdit: "Lokasyon Düzenle",
    locationName: "Lokasyon Adı",

    skillList: "Yetenek Listesi",
    skillsList: "Yetenek Listesi",
    skillDefine: "Yetenek Tanımla",
    skillCreate: "Yetenek Tanımla",
    skillsDefine: "Yetenek Tanımla",
    skillsCreate: "Yetenek Tanımla",
    skillEdit: "Yetenek Düzenle",
    skillsEdit: "Yetenek Düzenle",
    skillName: "Yetenek Adı",

    officeList: "Ofis Listesi",
    officeDefine: "Ofis Tanımla",
    officeCreate: "Ofis Tanımla",
    officeEdit: "Ofis Düzenle",
    officeName: "Ofis Adı",
    sapOfficeName: "Sap Ofis Adı",
    sapCapacity: "Sap Kapasite",

    sectorList: "Sektör Listesi",
    sectorsList: "Sektör Listesi",
    sectorDefine: "Sektör Tanımla",
    sectorCreate: "Sektör Tanımla",
    sectorsDefine: "Sektör Tanımla",
    sectorsCreate: "Sektör Tanımla",
    sectorEdit: "Sektör Düzenle",
    sectorsEdit: "Sektör Düzenle",
    sectorName: "Sektör Adı",

    meetingRoomCategorys: "Toplantı Odası Kategorileri",
    meetingRoomCategoriesList: "Toplantı Odası Kategori Listesi",
    meetingroomcategoriesList: "Toplantı Odası Kategori Listesi",
    meetingRoomCategoryDefine: "Toplantı Odası Kategori Tanımla",
    meetingRoomCategoryCreate: "Toplantı Odası Kategori Tanımla",
    meetingroomcategoriesDefine: "Toplantı Odası Kategori Tanımla",
    meetingroomcategoriesCreate: "Toplantı Odası Kategori Tanımla",
    meetingRoomCategoryEdit: "Toplantı Odası Kategori Düzenle",
    meetingroomcategoriesEdit: "Toplantı Odası Kategori Düzenle",
    meetingRoomCategoryName: "Toplantı Odası Kategori Adı",
    meetingRoomCategoriesName: "Toplantı Odası Kategori Adı",

    meetingRoomList: "Toplantı Odası Listesi",
    meetingroomList: "Toplantı Odası Listesi",
    meetingRoomDefine: "Toplantı Odası Tanımla",
    meetingRoomCreate: "Toplantı Odası Tanımla",
    meetingroomDefine: "Toplantı Odası Tanımla",
    meetingroomCreate: "Toplantı Odası Tanımla",
    meetingRoomEdit: "Toplantı Odası Düzenle",
    meetingroomEdit: "Toplantı Odası Düzenle",
    meetingRoomName: "Toplantı Odası Adı",
    cannotDeleteLastImage:
      "Bu alanda kayıtlı olan en az bir görsel olması gerekir, bunu silemezsin.",
    pleaseFillRequiredField: "Lütfen tüm gerekli alanları doldur",

    isUsingRadius: "Radius kullanıyor mu?",
    radiusUsername: "Radius Kullanıcı Adı",
    radiusServer: "Radius Sunucusu",
    radiusDatabase: "Radius Veritabanı",
    radiusPassword: "Radius Şifresi",

    perkscategory: "Perks Kategorileri",
    perksCategory: "Perks Kategorileri",
    perkscategoryList: "Perks Kategori Listesi",
    perksCategoryDefine: "Perks Kategori Tanımla",
    perkscategoryCreate: "Perks Kategori Tanımla",
    perksCategoryName: "Perks Kategori Adı",
    koPerksCategoryName: "Perks Kategori Adı",
    perkscategoryEdit: "Perk Kategorisi Düzenle",

    perks: "Perks",
    perksList: "Perks Listesi",
    perksDefine: "Perks Tanımla",
    perksCreate: "Perks Tanımla",
    perksName: "Perks Adı",
    koPerksName: "Perks Adı",
    perksEdit: "Perks Düzenle",
    perksOffer: "Sağlanan Fayda",
    koPerksOffer: "Sağlanan Fayda",
    expireDate: "Bitiş Süresi",

    perksSearch: "Perks Ara",
    perksCategorySearch: "Kategori",
    perksCaptureOffer: "İncele",
    similarPerks: "Benzer Perksler",
    detail: "Detay",

    onboardingNotificationEmail: "Yeni Üye Bildirim Mail Adresleri",
    nodataPerks: "Perks bulunamadı!",
    howDoUse: "Nasıl Kullanırım?",

    // ------- MeetingRoomDefine
    meetingRoomDefineName: "Adı",
    meetingRoomSummary: "Kısa Açıklama",
    meetingRoomAdminMessage: "Sadece Sistem Yöneticileri Rezervasyon Yapabilir",
    reservationTimeInterval: "Rezervasyon Yapılma Saat Aralığı",
    minimumMeetingDuration: "Minimum Toplantı Süresi",
    maximumMeetingDuration: "Maksimum Toplantı Süresi",
    cancellationDuration: "İptal Etme Süresi",
    maximumDaysForReservationInFuture: "İleri Tarihli Rezervasyon Yapma Limiti",
    cleaningDuration: "Toplantı Odası Yenilenme Zamanı",

    // ----- Question Category

    questioncategory: "Soru Kategorileri",
    questioncategoryList: "Soru Kategori Listesi",
    questionCategoryDefine: "Soru Kategorisi",
    questioncategoryCreate: "Soru Kategori Tanımla",
    questionCategory: "Soru Kategori",
    questionCategoryName: "Soru Kategori Adı",
    questioncategoryEdit: "Soru Kategorisi Düzenle",

    // ----- Question

    question: "Sorular",
    questionList: "Soru Listesi",
    questionDefine: "Soru",
    questionCreate: "Soru Tanımla",
    questionName: "Soru",
    questionEdit: "Soru Düzenle",
    lblAnswers: "Cevaplar",
    answer: "Cevap",
    newAnswer: "Yeni Cevap Ekle",
    sortOrder: "Sıra",
    waitingDay: "Bekleme Süresi (Gün)",

    // ----- Message
    messageList: "Mesaj Listesi",
    messageDefine: "Mesaj",
    messageCreate: "Mesaj Tanımla",
    endDate: "Bitiş Tarihi",
    priority: "Öncelik",
    messageType: "Mesaj Tipi",
    isActionRequired: "Aksiyon Zorunlu mu?",
    messageViewType: "Görüntüleme Tipi",
    viewType: "Görüntüleme Tipi",
    messageEdit: "Mesaj Düzenle",

    // ----- Notification Widget
    payNow: "Şimdi Öde",
    notifications: "Bildirimler",
    thanksforYourFeedback: "Geri bildirimin için teşekkürler",
    notificationEmpty: "Tebrikler, tüm bildirimleri okudun.",
    notification: "Bildirimler",
    readMore: "Daha Fazla",
    readLess: "Daha Az",
    unreadMessages: "Okunmamış {{messageCount}} yeni bildirim",

    week: "Hafta",
    month: "Ay",
    lastWeek: "Geçen Hafta",
    lastMonth: "Geçen Ay",
    last3Months: "Son 3 Ay",
    saltoLockName: "Salto Lock",
    saltoLock: "Salto Lock",
    color: "Renk",
    capacity: "Kapasite",
    guestCapacity: "Saatlik Misafir Kapasitesi",
    timing: "ZAMANLAMA",
    pricing: "ÜCRETLENDİRME",
    priceForHour: "Saatlik Ücret",
    taxRatio: "KDV Oranı",
    startTime: "Başlangıç Saati",
    endTime: "Bitiş Saati",

    // ------- Membership
    activationSuccess: "Hesabın başarıyla aktif edildi.",
    sentConfirmationLink:
      "Aktivasyon linkini kullanıcının email adresine gönderdik.",
    resendConfirmation: "Aktivasyon linki gönder",
    emailConfirmed: "Aktivasyon",
    confirmed: "Doğrulandı",
    notConfirmed: "Doğrulanmadı",
    hasActivation: "Aktive edilmiş",
    hasntActivation: "Aktivasyon linki gönder",
    lastActivationLink: "Aktivasyon Link",
    completeActivation: "Aktivasyonu tamamla",
    createPassword: "Şifre ekle",
    yourName: "Adın",
    yourLastname: "Soyadın",
    yourGender: "Cinsiyetin",
    yourAgeRange: "Yaş Aralığın",
    pickARange: "Tarih aralığı seç",
    personalInfo: "Kişisel Bilgiler",
    generalInfo: "Genel Bilgiler",
    paymentInfo: "Ödeme Bilgileri",
    name: "Adı",
    lastName: "Soyadı",
    lastname: "Soyadı",
    gender: "Cinsiyet",
    man: "Erkek",
    woman: "Kadın",
    none: "Belirtmek İstemiyorum",
    ageRangeName: "Yaş Aralığı",
    ageRange: "Yaş Aralığı",
    phoneNumber: "Cep Telefonu",
    shortBio: "Hakkında",
    company: "Şirket",
    definedOfficesToCompany: "Şirkete Tanımlı Ofisler",
    role: "Rol",
    social: "Sosyal Medya",
    linkedInUrl: "LinkedIn URL",
    instagramUrl: "Instagram URL",
    facebookUrl: "Facebook URL",
    twitterUrl: "Twitter URL",
    roles: "Roller",
    title: "Ünvan",
    membershipDefine: "Üye ya da Çalışan Tanımla",
    membershipCreate: "Üye ya da Çalışan Tanımla",
    membershipEdit: "Üye Düzenle",
    membershipList: "Üye Listesi",
    myProfile: "Profilim",
    myprofile: "Profilim",
    updateCompanyPicture: "Kapak Fotoğrafını Güncelle",
    updateUserPicture: "Kapak Fotoğrafını Güncelle",
    resetPassword: "Şifre Değiştir",
    resetpassword: "Şifre Değiştir",
    currentPassword: "Eski Şifre",
    newPassword: "Yeni Şifre",
    newPasswordConfirm: "Yeni Şifre Tekrar",
    isAccountOwner: "Hesap Sahibi Mi?",
    printerCode: "Yazıcı Kodu",
    saltoId: "Salto ID",
    systemAdminCreateAlertMessage:
      "'Sistem Yöneticisi' ekliyorsun, emin misin?",
    checkOutDate: "Çıkış Tarihi",

    membershipSegments: "Segmentler",
    segments: "Segmentler",
    userSegmentName: "Segment Adı",
    userSegment: "Segment",
    userSegmentDefine: "Segment Ekle",
    filterType: "Filtre Tipi",
    "membershipSegment-create": "Segment Ekle",
    "membershipSegment-edit": "Segment Düzenle",
    membershipFillMonthFilter: "X Ayını Dolduran Üyeler (Örn. 3)",
    //Enum FilterTypes
    allMemberships: "Tüm Üyeler",
    customFilter: "Özel Filtre",
    ticketResolved: "Çözülen Destek Talepleri",
    eventParticipants: "Etkinliğe Katılanlar",
    invoiceUnPaid: "Ödeme Yapılamayan Faturalar",
    csvImport: "Csv Dosyasından Ekleme",
    //

    birthday: "Doğum Günü",
    birthdayUpcoming: "Doğum Günü Yaklaşanlar (0=Bugün, 1=Dün)",
    isEventParticipations: "Etkinliğe Katılım Sağlayanlar",
    eventParticipation: "Katılım Sağlanan Etkinlikler",
    isOverMeetingRoomBooking: "Fazla Toplantı Odası Kullananlar",
    useMeetingRoomRate: "Toplantı Odası Kullanımı (Saat)",

    // ------- Settings
    meetingRoomAccessStartTime:
      "Rezervasyon saatine ne kadar zaman kala kapılar açılsın?",
    meetingRoomAccessEndTime:
      "Rezervasyon saati bitiminde ne kadar zaman sonra kapılar kapansın?",
    meetingRoomReservationInterval: "Rezervasyon yapma zaman aralığı",
    isRadiusServerEncryption:
      "Wifi radius server şifrelenmiş şifre kullanıyor mu?",

    // ------- KoDirectory
    noTeamData: "{{company}} şirketine ait ekip bulunamadı.",
    CompanyTeam: "{{companyName}} Ekibi",
    contacts: "İletişim Bilgileri",
    memberProfile: "Ekip Profili",
    memberprofile: "Ekip Profili",
    companyProfile: "Şirket Profili",
    companyprofile: "Şirket Profili",
    seeAllResults: '"{{query}}" için tüm sonuçları gör',
    kodirectorySearch: "Kişi, Şirket, Sektör, Yetenek Ara",
    about: "Hakkında",
    allResults: "Tüm Sonuçlar",

    // ------- Charts
    upcomingReservations: "Yaklaşan Toplantı Odası Rezervasyonlarım",
    shortMinute: "dk",
    longMinute: "Dakika",
    shortHour: "s",
    longHour: "Saat",
    noUpcomingReservations: "Yaklaşan toplantı odası rezervasyonun bulunmuyor.",
    debtBalance: "Borç Bakiyesi",
    lastInvoiceAmount: "Son Fatura Tutarı",
    teamSize: "Üye Kapasitesi",
    meetingRoomOccupancyRate: "Toplantı Odası Doluluk Oranı",
    totalNumberOfMembers: "Toplam Üye Sayısı",
    numberOfOutgoingMembers: "Çıkan Üye Sayısı",
    numberOfNewComers: "Gelen Üye Sayısı",
    paidMeetingRoomRevenue: "Ücretli Toplantı Odası Gelirleri",
    numberOfMembers: "Toplam Üye Sayısı",

    // ------- Reservations
    myReservations: "Toplantı Odası Rezervasyonu",
    myreservations: "Toplantı Odası Rezervasyonu",
    reservations: "Rezervasyon",
    reservationCalendar: "Toplantı Odası Rezervasyonu Takvimi",
    reservationcalendar: "Toplantı Odası Rezervasyonu Takvimi",
    newBooking: "Yeni rezervasyon ekle",
    newbooking: "Yeni rezervasyon ekle",
    editBooking: "Rezervasyon Düzenle",
    editbooking: "Rezervasyon Düzenle",
    selectMeetingRoom: "Toplantı Odası Seç",
    peopleToAttendTheMeeting: "Toplantıya Katılacak Kişiler",
    writeATitle: "Toplantı Başlığı",
    note: "Not",
    bookNow: "Rezervasyon Yap",
    startDate: "Başlangıç Tarihi",
    duration: "Süre",
    pickADate: "Tarih Seçiniz",
    pickATime: "Saat Seçiniz",
    pickADuration: "Süre Seçiniz",
    errorGettingFreeReservationCredit:
      "Şirketinin, kalan ücretsiz rezervasyon bilgisine ulaşılamadı",
    remainingFreeReservationCredit: "için kalan ücretsiz rezervasyon süresi",
    ticketType: "Destek Tipi",

    // Guest Reservations

    Guestreservations: "Misafir Rezervasyonu",
    guestreservations: "Misafir Rezervasyonu",
    numberOfGuest: "Misafir Sayısı",
    reservationDateTime: "Rezervasyon Tarihi",
    locationGuest: "Misafir Rezervasyonu",
    locationGuestDefine: "Misafir Rezervasyonu Tanımı",
    pleaseSelectDate: "Lütfen tarih seçiniz!",
    pleaseSelectHour: "Lütfen saat seçiniz!",
    pleaseSelectLocation: "Lütfen lokasyon seçiniz!",
    selectLocation: "Lokasyon seçiniz",
    selectHour: "Saat seçiniz",
    guests: "MİSAFİRLER",
    guestNameLastname: "Misafir Adı ve Soyadı",
    pleaseInputGuestNameLastname: "Lütfen misafir adını ve soyadını yazınız!",
    addGuest: "Misafir Ekle",
    entryButton: "Giriş Yap",
    outButton: "Çıkış Yap",
    outed: "Çıkış Yapıldı",
    entered: "Giriş Yapıldı",
    list: "Ofis Misafir Rezervasyonu",
    calendar: "Misafir Rezervasyonu Takvimi",
    // ------- Reservations
    noDescription: "Açıklama yazılmamış",
    feedbackScore: "Puan",
    solutionUserName: "İlgilenen Kişi",
    thanks: "Teşekkürler!",
    goToKoplanet: "OfficeLink'e git",
    feedbackTitle: "Geri bildirimlerini alalım",
    feedbackDescription:
      "İyileştirmelerin ve geri bildirimlerin bizim için çok değerli, aşağıdan bırakabilirsin.",
    ticketSave:
      "Destek talebini aldık, ilgileniyoruz. Sana en kısa zamanda dönüş yapacağız.",
    bookingCapacityExceeded:
      "Ücretsiz rezervasyon hakkın kalmadığı için, bu rezervasyonun ekstra olarak ücretlendirilecek.",
    ticket: "Destek",
    media: "Görsel",
    demandList: "Talep Listesi",
    demandlist: "Talep Listesi",
    myTickets: "Destek Taleplerim",
    mytickets: "Destek Taleplerim",
    assignedMe: "Bana Atananlar",
    assigntome: "Bana Atananlar",
    assignedtome: "Bana Atananlar",
    allTickets: "Tüm Destek Talepleri",
    alltickets: "Tüm Destek Talepleri",
    meetingroomusages: "Toplantı Odası Kullanım Raporu",
    // meetingRoomUsages: "Kullanım Raporu",
    reservationDate: "Tarih",
    createNewTicket:
      "Yeni bir destek talebi oluşturmak için butona basabilirsin.",
    categoryName: "Kategori Adı",
    categoryParent: "Üst Kategori",
    categoryChild: "Alt Kategori",
    ticketTitle: "Başlık",
    description: "Açıklama",
    noTicket: "Henüz açılmış bir destek talebi bulunmamaktadır.",
    solution: "Çözüm",
    processing: "İşlem Devam Ediyor",
    responsiblePersons: "Sorumlu Kişiler",
    ticketCategory: "Destek Kategorisi",
    ticketcategory: "Destek Kategorisi",
    ticketCategories: "Destek Kategorileri",
    ticketcategories: "Destek Kategorileri",
    ticketCategoriesName: "Kategori Adı",
    ticketCategoryDefine: "Destek Kategorisi Tanımla",
    ticketCategoryCreate: "Destek Kategorisi Tanımla",
    ticketcategoryDefine: "Destek Kategorisi Tanımla",
    ticketcategoryCreate: "Destek Kategorisi Tanımla",
    ticketCategoryEdit: "Destek Kategorisi Düzenle",
    ticketcategoryEdit: "Destek Kategorisi Düzenle",
    ticketCategoryList: "Destek Kategori Listesi",
    ticketcategoryList: "Destek Kategori Listesi",
    ticketCategoryName: "Kategori",
    ticketCategoryAssignUserList: "Ticket Kategori Sorumlu Listesi",
    ticketcategoryassignuser: "Ticket Kategori Sorumlumluları",
    ticketcategoryAssignUserDefine: "Destek Kategorisi Sorumlusu Tanımla",
    ticketCategoryAssignUser: "Sorumlu kişiler",
    isSolved: "Durum",
    isSolved_false: "Devam Ediyor",
    isSolved_true: "Tammalandı",
    inProcessing: "Devam Ediyor",
    completed: "Tamamlandı",
    ticketEdit: "Destek Talebi Güncelle",
    createTicket: "Destek Talebi Ekle",
    reservationEditWarning:
      "Bu rezervasyon sadece başlangıç saatinden {{cancellationDuration}} öncesine kadar düzenlenebilir.",
    meetingRoomLockOpenMessage:
      "Toplantı odasının kapısını rezervasyon zamanına {{meetingRoomAccessStartTime}} dakika kala açabilirsin",
    participant: "Katılımcı",
    deleteReservation: "Rezervasyonu Sil",
    close: "Kapat",
    bookingDeleted: "Rezervasyon Silindi",
    myBookings: "Rezervasyonlarım",
    bookFewSteps: "Bir kaç adımda toplantı odası rezervasyonunu yapabilirsin.",
    successBooking: "Rezervasyonun başarılı bir şekilde oluşturuldu.",
    successBookingEdit: "Rezervasyonun başarılı bir şekilde güncellendi.",
    reservationUpdated: "Rezervasyon Güncellendi",
    reservationCreated: "Rezervasyon Oluşturuldu",
    congratulations: "Tebrikler",
    ticketStatus: "Durum",
    Waiting: "Devam Ediyor",
    Solved: "Tamamlandı",
    UnSolvable: "Tamamlanamadı",
    deletedBooking: "Rezervasyonun silindi",
    time: "Saat",
    userInfo: "Üye Bilgileri",
    solutionUser: "İlgilenen kişi",
    solutionDate: "Çözüm Tarihi",
    relatedTicketCategory: "İlişkili Kategori",
    relatedTicketCategories: "İlişkili Kategoriler",
    comments: "Yorumlar",
    commentPlaceholder: "Soru sor veya talebin hakkında bilgi al...",
    comment: "Yorum Yap",
    monthlyFreeLimit: "AYLIK ÜCRETSİZ LİMİT",
    freeUse: "ÜCRETSİZ KULLANIM",
    freeRemaining: "ÜCRETSİZ KALAN",
    paidUse: "ÜCRETLİ KULLANIM",
    freeRemainingTransferMessage:
      "Kalan rezervasyon saatleri bir sonraki aylara devredemez.",
    requestOrSuggestion: "Talep/Öneri",
    complaint: "Şikayet",
    // ------- Payment
    ödendi: "Ödendi",
    ödenmedi: "Ödenmedi",
    account: "Hesabım",
    // financial: "Finansal İşlemler",
    subscriptions: "Abonelikler",
    creditCards: "Kredi Kartları",
    creditcards: "Kredi Kartları",
    invoiceExtract: "Fatura Ekstresi",
    invoiceextract: "Fatura Ekstresi",
    creditCard: "Kredi Kartı",
    creditCardList: "Kredi Kartları",
    creditcardlist: "Kredi Kartları",
    automaticPayment: "Otomatik Ödeme",
    automaticpayment: "Otomatik Ödeme",
    myCreditCards: "Kredi Kartları",
    mycreditcards: "Kredi Kartları",
    isDefault: "Otomatik Ödemede Kullan",
    creditCardDefine: "Kredi Kartı Tanımla",
    creditcardcreate: "Kredi Kartı Tanımla",
    cardAlias: "Kart Adı",
    expirationDate: "Son Kullanma Tarihi",
    cvc: "CVC",
    debitCardMessage:
      "Sadece kredi kartı tanımlanması gerekir. Bankamatik  ve ön ödemeli kartlar otomatik ödemede geçersizdir.",
    debitCardInvoiceMessage:
      "Bankamatik ve ön ödemeli kartlar ile faturanı ödeyebilirsin. Ancak bu kartlar daha sonra kullanılmak üzere kaydedilmez.",
    safelyStoredByIyzico1: "Kişisel bilgilerin,",
    safelyStoredByIyzico2: "iyzico",
    safelyStoredByIyzico3:
      "tarafından güvenle saklanır ve otomatik ödemeler için kaydedilir.",
    creditCardDeleteOrEditWarning:
      "Kayıtlı kredi kartlarını silme ya da kart bilgilerinde değişiklik yapma işlemi yalnızca OfficeLink ekibi tarafından yapılabilir.",
    deselect: "Seçimi kaldır",
    selectAll: "Tümünü Seç",
    removeAll: "Tümünü Kaldır",
    loadingInvoice: "Fatura Yükleniyor",
    errorLoadingInvoice: "Fatura yüklenemedi",
    approveUserAgreement1: "Kullanıcı",
    approveUserAgreement2: "sözleşmesini",
    approveUserAgreement3: "okudum ve onaylıyorum.",
    clickForDefineToCreditCard: "Yeni kredi kartı eklemek için tıkla!",
    approveIyzicoSystem1: "Kredi kartı bilgilerimin",
    approveIyzicoSystem2: "iyzico sistemiyle",
    approveIyzicoSystem3: "kaydedilmesini onaylıyorum.",
    iyzicoSystemTooltipMessage:
      "Sisteme kaydedeceğiniz tüm kredi kartları ve bilgileri, Iyzico tarafından PCI-DSS 1. Seviye sertifikasıyla güvenle saklanmaktadır.",
    definedCards: "Tanımlı Kartlar",
    paymentSuccess: "Ödeme başarıyla gerçekleştirildi",
    payableInvoiceAmount: "Ödenecek Fatura Tutarı",
    invoiceDetails: "Fatura Detayı",
    invoicedetails: "Fatura Detayı",
    gettingCardList: "Kredi kartları listesi alınıyor",
    exceed2MB: "Görsel 2 MB'den büyük olmamalı.",
    docDate: "Fatura Tarihi",
    documentNumber: "Fatura No",
    paidAmount: "Ödenen Tutar",
    unPaidAmount: "Ödenmeyen (Açık) Tutar",
    billStatus: "Durum",
    invoice: "Fatura",
    view: "Görüntüle",
    Paid: "Ödendi",
    UnPaid: "Ödenmedi",
    InsufficientBalance: "Bakiye Yetersiz",
    insufficientBalance: "Bakiye Yetersiz",
    AwaitingPayment: "Ödeme Bekleniyor",
    awaitingPayment: "Ödeme Bekleniyor",
    paymentType: "Ödeme Yöntemi",
    aCreditCardRequired:
      "İşlemlerine devam etmek için kredi kartı tanımlaman gerekiyor.",
    startAutomaticPayment: "Ödeme Al",
    selectedCardUseForAutoPayment:
      "Seçtiğin kart otomatik ödeme için kullanılır.",
    noDataForAutoPayment:
      "Otomatik ödemede kullanılabilecek bir fatura bulunmuyor.",
    noDataCreditCard: "Henüz sistemde tanımlı kredi kartı bulunmuyor",
    selectAutomaticPaymentCard:
      "Otomatik ödeme işleminde kullanılacak kredi kartını başarıyla belirledin.",
    documentAmount: "Fatura Tutarı",
    AFewMin: "Bu işlem birkaç dakika sürebilir.",
    payByAnotherCreditCard: "Başka bir kartla öde",
    paymentStatusMessage: "Otomatik Ödeme Durumu",
    autoPaymentChangeText:
      "Faturaların varsayılan kredi kartından her ay başında otomatik tahsil edilsin mi?",

    // ------- Event
    event: "Etkinlik",
    eventCategory: "Etkinlik Kategorileri",
    eventcategory: "Etkinlik Kategorileri",
    eventCategoryList: "Etkinlik Kategori Listesi",
    eventcategoryList: "Etkinlik Kategori Listesi",
    eventCategoryDefine: "Etkinlik Kategorisi Tanımla",
    eventCategoryCreate: "Etkinlik Kategorisi Tanımla",
    eventcategoryDefine: "Etkinlik Kategorisi Tanımla",
    eventcategoryCreate: "Etkinlik Kategorisi Tanımla",
    eventCategoryEdit: "Etkinlik Kategorisi Düzenle",
    eventcategoryEdit: "Etkinlik Kategorisi Düzenle",
    eventDetails: "Etkinlik Detayı",
    eventdetails: "Etkinlik Detayı",
    events: "Etkinlikler",
    eventList: "Etkinlik Listesi",
    eventCalendar: "Etkinlik Takvimi",
    eventcalendar: "Etkinlik Takvimi",
    participantList: "Katılımcılar",
    participantlist: "Katılımcılar",
    eventCategoryName: "Etkinlik Kategori Adı",
    icon: "İkon",
    eventDefine: "Etkinlik Tanımla",
    eventCreate: "Etkinlik Tanımla",
    eventEdit: "Etkinlik Düzenle",
    eventName: "Etkinlik Başlığı",
    eventPlace: "Etkinlik Alanı",
    planner: "Düzenleyici",
    url: "Url",
    eventCapacity: "Etkinlik Kapasitesi",
    backupCapacity: "Bekleme Listesi Kapasitesi",
    showEventWeb: "Etkinlik Web’te gösterilsin mi?",
    aPaidEvent: "Ücretli bir etkinlik mi?",
    price: "Ücret",
    currency: "Para Birimi",
    eventCancellationDuration: "Etkinliği İptal Etme Süresi",
    eventLocationType: "Lokasyon Tipi",
    internalLocation: "İç Lokasyon",
    externalLocation: "Dış Lokasyon",
    detailInfo: "Detaylı Bilgi",
    upcomingEvents: "Yakın Zamandaki Etkinlikler",
    gridView: "Izgara Görünümü",
    listView: "Liste Görünümü",
    nodataUpcomingEvent: "Yaklaşan etkinlik bulunmuyor.",
    showAllEvents: "Tüm Etkinlikleri Takvimde Görüntüle",
    eventDateTime: "Etkinlik Tarihi",
    joinEvent: "Etkinliğe Katıl",
    quotaFull: "Kontenjan Dolu",
    joinBackupList: "Bekleme Listesine Katıl",
    leaveBackupList: "Bekleme Listesinden Çık",
    giveUpFromJoin: "Katılmaktan Vazgeç",
    expired: "Süresi Doldu",
    eventCancelWarning:
      "Ücretli etkinliklere katılım başlangıç saatinden 1 saat önce iptal edilebilir.",
    similarEvents: "Benzer Etkinlikler",
    free: "Ücretsiz",
    noDataAvailableEvent: "Uygun Etkinlik Bulunamadı.",
    deleteIsDefaultCard:
      "Bu kartın otomatik ödemeler için tanımlı. Silmek istiyorsan, otomatik ödeme için başka bir kart tanımlayabilirsin.",

    // Digital Membership
    pleaseInputYourName: "Lütfen ad yazınız!",
    pleaseInputYourLastname: "Lütfen soyad yazınız!",
    pleaseInputEmail: "Lütfen email adresi yazınız!",
    // membership: "Üyelik İ",
    invoiceDetail: "Fatura Bilgileri",
    payment: "Ödeme",
    nameLastname: "Ad Soyad",
    identityNumber: "TC Kimlik Numarası",
    identityOrPassportNumber: "Kimlik veya Pasaport Numarası",
    address: "Adres",
    individual: "Şahıs",
    pleaseInputCompanyName: "Lütfen şirket adı yazınız!",
    pleaseInputNameLastname: "Lütfen şirket adı ve soyadı yazınız!",
    pleaseInputIdentityNumber: "Lütfen Tc kimlik numarası yazınız!",
    pleaseInputAddress: "Lütfen adres yazınız!",
    vatOffice: "Vergi Dairesi",
    pleaseInputVatOffice: "Lütfen vergi dairesini yazınız!",
    vatNumber: "Vergi Numarası",
    pleaseInputVatNumber: "Lütfen vergi numarasını yazınız!",
    cardHolderName: "Kredi Kartı Üzerindeki İsim",
    pleaseInputCardHolderName: "Lütfen kredi kartının üzerindeki ismi yazınız!",
    cardNumber: "Kredi Kartı Numarası",
    pleaseInputCardNumber: "Lütfen kredi kartı numarasını yazınız!",
    cardMonth: "Ay",
    pleaseInputCardMonth: "Lütfen ay seçiniz!",
    cardYear: "Yıl",
    pleaseInputCardYear: "Lütfen yıl seçiniz!",
    cardCvc: "CVC",
    pleaseInputCardCvc: "Lütfen güvenlik numarasını yazınız!",
    maximumCharacterLimit4: "En fazla 4 karakter olabilir!",
    maximumCharacterLimit10: "En fazla 10 karakter olabilir!",
    maximumCharacterLimit11: "En fazla 11 karakter olabilir!",
    minimumCharacterLimit3: "En az 3 karakter olabilir!",
    minimumCharacterLimit10: "En az 10 karakter olabilir!",
    minimumCharacterLimit11: "En az 11 karakter olabilir!",
    subscriptionMonth: "ay",
    pleaseCheckAgreement: "Lütfen sözleşmeyi kabul edin!",

    cardDistanceSalesContract: "Mesafeli Satış Sözleşmesini",
    cardPreliminaryInformationFormContract: "Ön Bilgilendirme Formunu",
    cardAgreement: "{{cardDistanceSalesContract}} okudum ve kabul ediyorum.",
    cardAgreementVirtualOffice: "{{cardDistanceSalesContract}} ve {{cardPreliminaryInformationFormContract}} okudum ve kabul ediyorum.",
    cardAgreementNomad: "{{cardDistanceSalesContract}} ve {{cardPreliminaryInformationFormContract}} okudum ve kabul ediyorum.",
    pay: "{{price}} TRY Öde",
    digitalMemberShipTitle:
      "Online üyeliğinizi şimdi başlatın!",
    vat: "KDV",
    pleaseSelectPeriod: "Lütfen üyelik süresi seçiniz!",
    period: "Üyelik süresi",
    productType: "Tercih ettiğin üyelik tipi?",
    pleaseSelectProductType: "Lütfen üyelik tipi seçiniz!",
    welcomeAboard: "Aramıza hoşgeldin {{name}}",
    digitalMembershipSuccess: "Üyeliğin tamamladı!",
    onlineSalesSuccess: "Tebrikler üyeliğin tamamladı!",
    digitalMembershipSuccessEmail:
      "E-posta adresine aktivasyon linki gönderdik. İlgili linkten üyeliğini aktifleştirebilirsin.",
    // Daily Pass

    dailypass: "Günlük Giriş Rezervasyonu",
    dailypassEmptyData: "Günlük giriş kaydı oluşturun",
    dailyPassCapacity: "Günlük Daily Pass Kapasitesi",
    sapId: "Sap Şube Kodu",
    sapProjectId: "Sap Proje Kodu",
    dailypasslist: "Günlük Giriş Rezervasyonlarım",
    freeUsageThisMonth: "BU AY ÜCRETSİZ KULLANIM HAKKI",
    payWithDifferenCreditCard: "Farklı Kredi Kartı ile Öde",
    isSavedCreditCard: "Kredi kartımın diğer ödemeler için kaydedilmesini istiyorum.",
    dailypassPayButtonText: "{{price}} TRY Öde ve Kaydet",
    pleaseSelectCreditCard: "Lütfen kredi kartı seçiniz!",
    cancelIt: "İptal et",
    canceled: "İptal edildi",
    dailyPassCannotBeCanceled: "Günlük giriş rezervasyonu, kullanım gününden birgün öncesine kadar iptal edilebilir.",
    dailyPassCancelWarningText: "Günlük Giriş rezervasyonu iptal edilerek ücretsiz kullanım hakkına yüklenecektir, onaylıyor musun?",
    cancellationDescription: "Bu Günlük Giriş rezervasyon iptali için ilgili ayın ücretsiz kullanım haklarına 1 gün otomatik eklenmiştir.",

    // Daily Pass Check
    find: "Sorgula",

    documentName: "Dosya Adı",
    paperSize: "Sayfa Boyutu",
    cost: "Tutar",
    totalPages: "Toplam Sayfa",
    records: "Kayıt",
    totalColorPages: "Renkli",
    totalGrayScalePages: "Siyah Beyaz",
    usageDate: "Tarih",
    pages: "Sayfa",
    amount: "Tutar",
    printerusages: "Yazıcı Kullanım Raporu",


    //Report
    dailypasscheck: "Günlük Giriş Sorgulama",
    fullname: "Üye",
    digitalMembership: "Online Üyelik",
    reset: "Sıfırla",
    fieldIsRequired: "Bu alan zorunlu",
    choose: "Seçiniz",
    sapGeneralProjectId: "Merkez Sap Proje Kodu",
    true: "Evet",
    false: "Hayır",
    isDigitalMembership: "Online Üyelik",
    companyAuthorization: "Yetkili Şirketler",


    // Promotion Code
    code: "Promosyon Kodu",
    percentageOfDiscount: "İndirim Yüzdesi",
    promotionCode: "Promosyon Kodu",
    PromotionCode: "Promosyon Kodu",
    promotioncode: "Promosyon Kodu",
    promotioncodeList: "Promosyon Kodu Listesi",
    numberOfUses: "Kullanım Sayısı",
    promotioncodeCreate: "Promosyon Kodu Tanımla",
    promotionCodeCreate: "Promosyon Kodu Tanımla",
    promotioncodeEdit: "Promosyon Kodu Düzenle",
    used: "Kullanılan",
    normal: "Normal",
    FirstMonthIsFree: "İlk Ay Ücretsiz",
    FirstMonthIsFreeAfterAutoCancellation: "İlk Ay Ücretsiz Sonra Otomatik Durdur",
    promotionType: "Promosyon Tipi",

    numberOfPeople: "Kişi Sayısı",
    isDailyLease: "Günlük Kiralanabilir Mi?",
    dailyPrice: "Günlük Kiralama Fiyatı",

    dailyrents: "Günlük Ofis Rezervasyonu",
    dailyrentsDescriptionTitle: "Günlük ofis rezervasyonu ile tüm lokasyonlarda çalışmak artık çok kolay!",
    dailyrentsDescription: "Aşağıdan çalışmak istediğiniz ofisi seçin ve günlük kiralayın.",
    dailyrentslist: "",
    checkout: "Ödeme",
    dailyrentPayButtonText: "{{price}} TRY Öde ve Hemen Kirala",
    rentNow: "Hemen Kirala",
    dailyRentSuccessMessage: "Günlük ofis rezervasyonu işleminiz başarılı bir şekilde tamamlandı. İlgili tarih de lokasyona giderek ofisinizi kullanabilirsiniz.",
    lastDailyRents: "ÖNCEKİ REZERVASYONLAR",
    dailyrentprevious: "Önceki Rezervasyonlar",
    dailyrentreport: "Günlük Ofis Rezervasyonu Raporu",
    answerType: "Cevap Tipi",
    answerTypeMessage: "Cevap yaz...",
    dailyRentNotFoundTitle: "Aradığın gün ve kriterlerde uygun ofis bulamadıysan bizimle iletişime geçebilirsin.",
    dailyRentNotFoundDescription: "Sana en uygun ofisi hemen bulalım.",
    dailyRentType: "İşlem Tipi",
    sales: "Satış",
    previous: "Geçmiş",


    //idea

    idea: "Geri Bildirim",
    ideaPlaceHolder: "Bi' fikrini buraya yazabilirsin...",
    ideaEmails: "Bi' fikrim var mail adresleri",
    ideareport: "Geri Bildirim Raporu",
    ideaFeedbackTitle: "OfficeLink deneyiminden ne kadar memnunsun?",
    ideaAvarageRateText: "Ortalama puan : {{rate}}",


    //feedback
    feedbacks: "Geri Bildirimler",
    feedbacksList: "Geri Bildirim Listesi",
    feedbackQuestion: "Soru",
    feedbacksEdit: "Düzenle",
    feedbacksCreate: "Ekle",
    feedbacksRates: "Puanlar",
    feedback: "Geri bildirim",
    frequency: "Frekans",
    weekly: "Haftalık",
    monthly: "Aylık",
    rate: "Puan",
    minText: "En düşük için açıklama",
    maxText: "En yüksek için açıklama",


    newCompanyCreate: "Yeni Şirket Ekle",
    newMemberCreate: "Yeni Üye Ekle",
    newSegmentCreate: "Yeni Segment Ekle",
    newFeedbackCreate: "Yeni Geri Bildirim Ekle",
    newLocationCreate: "Yeni Lokasyon Ekle",
    newOfficeCreate: "Yeni Ofis Ekle",
    newSkillCreate: "Yeni Yetenek Ekle",
    newMeetingroomCategoryCreate: "Yeni Toplantı Odası Kategorisi Ekle",
    newMeetingroomCreate: "Yeni Toplantı Odası Ekle",
    newTicketCategoryCreate: "Yeni Destek Kategorisi Ekle",
    newTicketCategoryAssignUserCreate: "Yeni Sorumlu Ekle",
    newTicketCreate: "Yeni Destek Ekle",
    newEventCreate: "Yeni Etkinlik Ekle",
    newSectorCreate: "Yeni Sektör Ekle",
    newEventCategoryCreate: "Yeni Etkinlik Kategorisi Ekle",
    newPerksCreate: "Yeni Perks Ekle",
    newPerksCategoryCreate: "Yeni Perks Ketegorisi Ekle",
    newPromotionCodeCreate: "Yeni Promosyon Kodu Ekle",
    newDailypassCreate: "Yeni Günlük Giriş Rezervasyonu Ekle",
    newMeetingroomReservasationCreate: "Yeni Rezervasyon Ekle",
    newGuestReservationCreate: "Yeni Misafir Rezervasyonu Ekle",
    newCreditCardCreate: "Yeni Kredi Kartı Ekle",
    newMessageCreate: "Yeni Mesaj Ekle",
    newQuestionCategoryCreate: "Yeni Soru Kategorisi Ekle",
    newQuestionCreate: "Yeni Soru Ekle",
    source: "Kaynak",

    // products
    product: "Ürün",
    definitionsProducts: "Ürünler",
    products: "Ürünler",
    productsEdit: "Düzenle",
    productsCreate: "Ekle",
    newProductCreate: "Yeni Ürün Ekle",
    shortDescription: "Kısa Açıklama",
    locks: "Kapı Kilitleri",
    vatPercentage: "Kdv Oranı",
    priceType: "Fiyat Tipi",
    quantity: "Adet",
    action: "Aksiyon",
    prices: "Fiyatlar",
    features: "Özellikler",
    onlineSalesFooterNotFoundTitle: "Aradığın kriterlerde uygun ofis bulamadıysan bizimle iletişime geçebilirsin.",
    onlineSalesFooterNotFoundDescription: "Sana en uygun ofisi hemen bulalım.",
    onlineSalesFixedOfficeTitle: "ÖZEL OFİS",
    onlineSalesFixedOfficeDescription: "Detaylarla uğraşmadan, konforun bir çalışma ortamının tadını çıkar!",
    onlineSalesNomadTitle: "GEZGİN",
    onlineSalesNomadDescription: "Bir ofise ihtiyaç duyduğun her an için OfficeLink!",
    onlineSalesVirtualOfficeTitle: "SANAL OFİS",
    onlineSalesVirtualOfficeDescription: "Şirketin için en prestijli adres OfficeLink Sanal Ofis.",
    emptyText: "Kriterlere uygun kayıt bulunamadı!",
    onlineSalesSuccessTitleWithLogin: "Tebrikler, satın alma işleminiz başarıyla gerçekleşti.",
    onlineSalesSuccessDescriptionWithLogin: "İşlem faturanıza Hesabım > Faturalar bölümünden erişim sağlayabilirsiniz.",
    contactUs: "İletişime geç",

    // product type
    FixedOffice: "Özel Ofis",
    VirtualOffice: "Sanal Ofis",
    VirtualOfficeForUsed: "Sanal Ofis Kullanımlı",
    Nomad: "Gezgin",
    DigitalMembership: "Dijital Üyelik",
    MeetingRoom: "Toplantı Odası",
    DailyPass: "Günlük Kullanım",
    DoorEntryMobileApp: "Mobil Uygulama ile Giriş",
    PrinterA4Grayscale: "Yazıcı A4 Siyah Beyaz",
    PrinterA4Colored: "Yazıcı A4 Renkli",
    PrinterA3Grayscale: "Yazıcı A3 Siyah Beyaz",
    PrinterA3Colored: "Yazıcı A3 Renkli",

    // price type
    General: "Genel",
    LocationBase: "Lokasyon Bazlı",

    createdUser: "Oluşturan",
    lastModifiedUser: "Son Güncelleyen",
    integrationCode: "Entegrasyon Kodu",

    // contracts

    subscription: "Abonelik",
    subscriptionAdd: "Yeni Abonelik Ekle",
    membershipSubscriptions: "Abonelikler",
    subscriptionsCreate: "Ekle",
    subscriptionsEdit: "Düzenle",
    signDate: "İmza Tarihi",
    CreditCard: "Kredi Kartı",
    BankTransfer: "Banka Transferi",
    Draft: "Taslak",
    Active: "Aktif",
    Ended: "Sonlandı",
    Removed: "Silindi",
    paymentRange: "Faturalama Sıklığı",
    youCanOnlyAddPdfFile: "Sadece pdf dosyası ekleyebilirsiniz.",
    nextRenewalDate: "Yenileme Tarihi",
    cancelSubscription: "Aboneliği Sonlandır",
    cancelSubscriptionSuccessMessage: "Abonelik iptal isteğin başarılı bir şekilde alındı.",
    cancellationDate: "İptal Edilecek Tarih",
    cancellationInfoMessage: "Bu abonelik için {{cancellationRequestDate}} tarihinde sonlandırma isteği alındı. Bu abonelik {{cancellationDate}} tarihinde sonlandırılacak!",
    cancellationInfoMessageTitle: "Abonelik Sonlandırma İsteği",
    cancellationRemoveButton: "İptal İsteğini Sil",
    subscriptionItemAreYouSureYouWantToDelete: "Sözleşme aktif olduğu için silme isteğiniz alınacak ve {{renewalDate}} tarihinde otomatik silinecektir. Onaylıyor musunuz?",
    updates: "Güncellemeler",
    subscriptionItemDelete: "Durdurulacak",
    subscriptionItemNew: "Eklenecek",
    now: "Şimdi",
    onTheRenewalDate: "Abonelik Güncelleme Tarihinde",
    renewalsTime: "Kullanma Zamanı",
    addProduct: "Ürün Ekle",
    invoicePeriod: "Faturalama Dönemi",
    isStartedDescription: "{{date}} tarihinde otomatik başlayacak.",
    youDontHaveSubscripitionTitle: "Aktif aboneliğin bulunmuyor!",
    youDontHaveSubscripitionDescription: "Bir üyelik satın alarak OfficeLink'in tüm imkanlarından faydalanabilirsin.",
    isRentCardReader : "Kart Okuma Kiralama Anlaşması Var Mı?",
    isPassengerOnboard : "Kart Okuma ve Mobil Cihazdan Bilgi Alınıyor Mı?",
    isEditRouteVendor : "Tedarikçi Güzergah Oluşturup Düzenleyebilsin mi?",


    // online sales

    minumumCharacterLimit: "En az {{number}} karakter olması gerekir",
    maximumCharacterLimit: "En fazla {{number}} karakter olması gerekir",

    // invoice

    invoices: "Faturalar",
    totalPrice: "Tutar",
    totalVatPrice: "Kdv Tutarı",
    totalAmount: "Toplam",
    total: "Toplam",
    paymentStatus: "Ödeme Durumu",
    dueDate: "Vade Tarihi",
    filter: "Filtrele",
    eInvoice: "E-fatura",
    invoiceType: "Fatura Tipi",
    Penalty: "Ceza Faturası",
    Sales: "Satış Faturası",

    Hourly: "Saatlik",
    Daily: "Günlük",
    Monthly: "Aylık",
    Yearly: "Yıllık",
    Piece: "Adet",

    everyMonth: "Aylık",
    onceIn3Months: "3 Ayda Bir",
    onceIn6Months: "6 Ayda Bir",
    yearly: "Yıllık",
    subscriptionDuration: "Abonelik Süresi",
    areYouSureYouWantToDelete: "Silmek istediğine emin misin?",
    paymentAmount: "Ödeme Tutarı",
    subscriptionAmount: "Abonelik Tutarı",
    subscriptionEndDate: "Abonelik Bitiş Tarihi",
    autoRenew: "Otomatik Yenilensin Mi?",
    addFile: "Dosya Ekle",
    file: "Dosya",
    online: "Online",
    offline: "Offline",
    profileImage: "Profil Resmi",
    invoiceView: "Faturayı Görüntüle",

    // webhook transaction
    webhooklogs: "Webhook Logları",
    transactionId: "İşlem Numarası",
    requestDate: "Zaman",
    endpoint: "Endpoint",
    httpMethod: "Http Method",
    responseStatusCode: "Response Status Code",
    elapsedMiliseconds: "İşlem Süresi",
    companyUpdate: "company:update",
    companyGet: "company:get",
    companyGets: "company:gets",
    invoiceCreate: "invoice:create",
    invoiceGet: "invoice:get",
    invoicePaymentCreate: "invoice:payment:create",
    invoicePaymentDelete: "invoice:payment:delete",


    // bank
    bank: "Banka",
    definitionsBanks: "Bankalar",
    banks: "Bankalar",
    newBankCreate: "Yeni Banka Ekle",
    banksEdit: "Düzenle",
    banksCreate: "Ekle",

    // invoice payment
    invoiceId: "Fatura No",
    creditCardPaymentId: "KK Tahsilat No",
    creditCardTransactionId: "KK İşlem No",
    invoicepayments: "Tahsilatlar",
    curreny: "Para Birimi",
    addPayment: "Ödeme Ekle",
    Partial: "Kısmi Ödendi",
    invoicePayment: "Ödeme",
    amoutDue: "Alacak Tutarı",
    payments: "Ödemeler"
  },
};

tr.el = elementLocaleTR.el;

tr.el.pagination.pagesize = "/Sayfa";

export default tr;



// WEBPACK FOOTER //
// ./src/plugins/i18n/locales/tr.js